import axios from "axios";

// Resolve the backend URL preferring **same-origin** in production.
//
// Why: when the site is served from a custom domain (e.g. thisthatforme.com)
// but the build's REACT_APP_BACKEND_URL points to a different host like
// creator-store-56.emergent.host, every API call becomes cross-origin.
// Safari's Intelligent Tracking Prevention, Brave Shields, and Firefox
// "Strict" privacy mode all silently block such requests — the form spins
// forever and the customer can't check out. Emergent's ingress proxies
// `/api/*` on the custom domain to the backend, so same-origin works.
const ENV_BACKEND = process.env.REACT_APP_BACKEND_URL || "";

function resolveBackendUrl() {
  if (typeof window === "undefined") return ENV_BACKEND;
  const host = window.location.hostname;
  const isClusterHost =
    host.endsWith(".emergent.host") ||
    host.endsWith(".preview.emergentagent.com") ||
    host.endsWith(".emergentagent.com") ||
    host === "localhost" ||
    host === "127.0.0.1";
  if (!isClusterHost) {
    // Custom domain → call the API on the same origin (no CORS, no privacy
    // blocking). E.g. thisthatforme.com/api/*.
    return `${window.location.protocol}//${window.location.host}`;
  }
  // Cluster preview / local dev — env var is the right answer.
  return ENV_BACKEND;
}

const BACKEND_URL = resolveBackendUrl();
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
